<div class="ui-g-12">

    <div class="ui-g">
        <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
            <app-infobox [pointData]="indicator.pointData" [penetration]="indicator.penetration" [t]="indicator.t" [options]="indicator.options"></app-infobox>
        </div>
    </div>

    <div class="campaigncharts" *ngIf="data != null">
        <div class="ui-g">
            <div class="ui-g-12 ui-md-3 ui-sm-12">
                <h2>{{ translations.consentKCustomers }}</h2>
                <div class="chart-container">
                    <chart [options]="consentKCustomersChart.options"
                           (load)="setChartInstance(consentKCustomersChart, $event.context)"></chart>
                </div>
            </div>

            <div class="ui-g-12 ui-md-6 ui-sm-12">
                <h2>{{ translations.contactableTrend }}</h2>
                <div class="chart-container">
                    <chart [options]="trendChart.options"
                           (load)="setChartInstance(trendChart, $event.context)"></chart>
                </div>
            </div>


            <div class="ui-g-12 ui-md-3 ui-sm-12">
                <div class="global-search-ptable">
                    <input type="text" placeholder="{{ translations.searchInDescription }}" (input)="applayFilter($event.target.value)" />
                    <span aria-hidden="true" class="button-search fa fa-search"></span>
                </div>
                <p-table [value]="datatable" class="overview-table" [sortMode]="'multiple'" >

                    <ng-template pTemplate="header">
                        <tr>
                            <th [pSortableColumn]="'desc'">
                                <span class="sortableCol">{{ translations.description }}</span>
                                <p-sortIcon class="sortableIcon" [field]="'desc'"></p-sortIcon>
                            </th>
                            <th [pSortableColumn]="'cont'">
                                <span class="sortableCol">{{ translations.contactable }}</span>
                                <p-sortIcon class="sortableIcon" [field]="'cont'"></p-sortIcon>
                            </th>
                            <th [pSortableColumn]="'prof'">
                                <span class="sortableCol">{{ translations.profiling }}</span>
                                <p-sortIcon class="sortableIcon" [field]="'prof'"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-col>
                        <tr id="index-{{ col.index }}">
                            <td class="number-column">{{ col.desc }}</td>
                            <td class="number-column">{{ col.cont }}</td>
                            <td class="number-column">{{ col.prof }}</td>
                        </tr>
                    </ng-template>

                </p-table>
            </div>



        </div>
    </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers-contactable/contactable-consent/contactable-consent.component.html